import { Country } from "@/types";
import { getFlag, useClickOutside } from "@/utils";
import { useRef } from "react";
import "./CountriesDropdown.scss";

type Props = {
    countries: Country[],
    onSelect: (country: Country) => void,
    close: () => void,
    parentClass?: string
}

export const CountriesDropdown = ({ countries, onSelect, close }: Props) => {
    const listRef = useRef(null);

    useClickOutside(listRef, () => {
        close();
    }, "invoice-area__country");

    return <div className="countries" ref={listRef}>
        <ul className="countries__list">
            {countries.length > 0 ? <> {countries.map((country, i) => <li className="countries__item" key={i}>
                <button className="countries__select-country" type="button" onClick={() => {
                    onSelect(country);
                }}>
                    <p>{getFlag(country.code)}</p>
                    <p>{country.name}</p>
                </button>
            </li>)}</> :
                <div className="countries__empty">
                    <p>Not found</p>
                </div>}
        </ul>
    </div>
}

